import { useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import Config from '../../../utils/Config';
import styles from './GoogleDataAccess.module.css';

const GoogleDataAccess = (props) => {

  const { requiredScopes = [], icon, project, onAccessGrant, provider, onLoginReady, onLoadingChange } = props;

  const login = useGoogleLogin({
      onSuccess: async (code) => {

        var gtkn = code["code"]
        if ( gtkn != null) {
          // Grant-access loader centralization (requirement 3): the popup
          // closing gives no visual feedback on its own -- this call is the
          // first of the two the account-connect flow makes (save tokens,
          // then the caller's own list-accounts call from onAccessGrant), so
          // the loading flag is raised here and only cleared by whichever of
          // this call's own catch, or the caller's post-onAccessGrant work,
          // determines the flow is done. onLoadingChange is optional so this
          // component's un-managed/standalone usage is unaffected.
          onLoadingChange?.(true);

          axios.post(Config.BASE_URL + '/datasource/google/save-google-access-tokens',
              {
                "gcode" : gtkn,
                "project_id": project.id,
                "provider": provider,
              },
            {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            },
          ).then(responseJSON => {
            // console.log('Google Data Access tokens saved successfully: ', responseJSON);
            onAccessGrant(responseJSON.data || []);
          }).catch(err => {
            console.error('Error saving Google Data Access tokens:', err);
            onLoadingChange?.(false);
          });
        }
      },
      flow: 'auth-code',
      scope: requiredScopes.length > 0 ? requiredScopes.join(' ') : undefined,
      // TRD: oauth-credential-product-granularity/trd.md, Section 0.2/3.2 —
      // when a project already has any Google product connected and the
      // user connects a second one, request only this product's own
      // requiredScopes (unchanged) but with include_granted_scopes so
      // Google's token response covers the union of all previously +
      // newly granted scopes, instead of narrowing to just this request.
      // Confirmed (@react-oauth/google 0.12.2 dist/index.d.ts's
      // CodeClientConfig) this is a first-class typed option the hook
      // spreads straight into GIS's initCodeClient.
      include_granted_scopes: true,
      onError: (error) => console.log('Saving Access Details Failed:', error)
  });

  // Expose login to parent so it can be called directly from a click handler
  // (user gesture context), avoiding popup blocking.
  useEffect(() => {
    onLoginReady?.(login);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // In managed mode the parent owns the trigger — render nothing.
  if (onLoginReady) return null;

  return (
    <img
      src={icon}
      alt="Sign in with Google"
      onClick={() => login()}
      className={styles.iconButton}
    />
  )
}

export default GoogleDataAccess;